import { Stack } from '@mui/material';

type FormActionsMuiDefaultLayoutProps = {
  leftActions: React.ReactNode;
  rightActions: React.ReactNode;
  actionsWrap?: boolean;
};

/** Default single-row layout for left (discard/cancel) and right (draft/submit) actions. */
export function FormActionsMuiDefaultLayout({
  leftActions,
  rightActions,
  actionsWrap = false,
}: FormActionsMuiDefaultLayoutProps) {
  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      sx={actionsWrap ? { display: 'flex', flexWrap: 'wrap' } : undefined}
    >
      {leftActions}
      {rightActions}
    </Stack>
  );
}
